import BaseApi from 'api/base';
import { CREATE_ORDER_URL } from 'api/constants';

export default {
  // used only for rerx
  createOrder: (params: IOrderRequest) => {
    return BaseApi.authRequest(
      CREATE_ORDER_URL(),
      {
        method: 'POST',
        body: JSON.stringify({
          ...params,
        }),
      },
      true,
    );
  },
};
